import Vue from 'vue';

export default {
  state: {
    due_dates: [],
  },
  getters: {
    due_dates(state) {
      return state.due_dates;
    },
    // eslint-disable-next-line
    due_day: state => (id) => {
      return state.due_dates.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_DUE_DATES(state, payload) {
      state.due_dates = payload;
    },
  },
  actions: {
    GET_DUE_DATES(context) {
      return Vue.axios.get('filters/due_dates').then((response) => {
        context.commit('SET_DUE_DATES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/due_dates.js